import { pathOr } from '@xingternal/malt-util';

// Incremental-search
export const hasSearchSuggestionsSelector = (state) =>
  pathOr(false, ['hasSearchSuggestions'], state);
export const hasPredictiveSearchSelector = (state) =>
  pathOr(false, ['hasPredictiveSearch'], state);
export const searchSuggestionsSelector = (state) =>
  pathOr([], ['searchSuggestions'], state);
export const predictiveSearchSelector = (state) =>
  pathOr({}, ['predictiveSearch'], state);
export const searchTermSelector = (state) => pathOr('', ['searchTerm'], state);
export const activateSearchBarSelector = ({ activateSearchBar }) =>
  activateSearchBar;
export const activatePredictiveSearchBarSelector = ({
  activatePredictiveSearchBar,
}) => activatePredictiveSearchBar;
export const deactivateSearchBarSelector = ({ deactivateSearchBar }) =>
  deactivateSearchBar;
export const deactivatePredictiveSearchBarSelector = ({
  deactivatePredictiveSearchBar,
}) => deactivatePredictiveSearchBar;
export const triggerSearchInputSelector = ({ triggerSearchInput }) =>
  triggerSearchInput;
export const triggerPredictiveSearchInputSelector = ({
  triggerPredictiveSearchInput,
}) => triggerPredictiveSearchInput;
export const executeSearchTrackingSelector = ({ executeSearchTracking }) =>
  executeSearchTracking;
